(function () {
  // Event delegation on document — works even after Shopify re-renders
  // the section HTML (theme customizer live preview, section reloads, etc.)
  // No per-instance setup needed, so buttons never go "dead" after an edit.

  function getStep(track) {
    var firstSlide = track.querySelector('.cb-slide');
    if (!firstSlide) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || 0) || 0;
    return firstSlide.getBoundingClientRect().width + gap;
  }

  function updateButtonsForTrack(track) {
    var section = track.closest('.cb-section');
    if (!section) return;
    var prevBtn = section.querySelector('.cb-nav--prev');
    var nextBtn = section.querySelector('.cb-nav--next');
    if (!prevBtn && !nextBtn) return;

    var scrollLeft = track.scrollLeft;
    var maxScroll = track.scrollWidth - track.clientWidth - 2;

    if (prevBtn) prevBtn.disabled = scrollLeft <= 0;
    if (nextBtn) nextBtn.disabled = scrollLeft >= maxScroll;
  }

  function updateAllTracks() {
    document.querySelectorAll('.cb-track').forEach(updateButtonsForTrack);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.cb-nav--prev, .cb-nav--next');
    if (!btn) return;
    var section = btn.closest('.cb-section');
    if (!section) return;
    var track = section.querySelector('.cb-track');
    if (!track) return;

    var direction = btn.classList.contains('cb-nav--prev') ? -1 : 1;
    track.scrollBy({ left: direction * getStep(track), behavior: 'smooth' });
  });

  // Capture phase: scroll events don't bubble, but capturing on document
  // still catches them fired on any descendant during the capture pass.
  document.addEventListener(
    'scroll',
    function (event) {
      var target = event.target;
      if (target && target.classList && target.classList.contains('cb-track')) {
        updateButtonsForTrack(target);
      }
    },
    { passive: true, capture: true }
  );

  window.addEventListener('resize', updateAllTracks);
  document.addEventListener('DOMContentLoaded', updateAllTracks);

  // Re-check button state whenever a section is added/reloaded in the
  // theme customizer (Shopify fires this on every settings change).
  document.addEventListener('shopify:section:load', updateAllTracks);
})();